import { useId } from "react";

/** Broad material planes remain legible in small prices and the resource HUD. */
export function ResourceIcon({ kind, size = 12 }: { kind: string; size?: number }): JSX.Element {
  const id = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-label={kind} role="img">
      <defs>
        <linearGradient id={id} x2=".7" y2="1">
          <stop
            stopColor={
              kind === "iron"
                ? "#d5e4e9"
                : kind === "wood"
                  ? "#d59b54"
                  : kind === "clay"
                    ? "#eea76c"
                    : "#ffe095"
            }
          />
          <stop
            offset="1"
            stopColor={
              kind === "iron"
                ? "#596f79"
                : kind === "wood"
                  ? "#774224"
                  : kind === "clay"
                    ? "#ad4e32"
                    : "#c68a2c"
            }
          />
        </linearGradient>
      </defs>
      <ellipse cx="16" cy="28" rx="12" ry="2.5" fill="#213d36" opacity=".18" />
      {kind === "wood" ? (
        <g stroke="#734426" strokeWidth="1">
          <path d="M4 19 19 12 27 17 12 26Z" fill={`url(#${id})`} />
          <path d="M3 12 19 5 27 10 11 19Z" fill={`url(#${id})`} />
          <path d="m6 13 15-6M6 21l14-6" stroke="#f4c787" />
          <ellipse cx="25" cy="13" rx="4" ry="5" fill="#efc48a" />
          <ellipse cx="25" cy="13" rx="2" ry="3" fill="none" />
          <ellipse cx="24" cy="21" rx="4" ry="5" fill="#efc48a" />
          <ellipse cx="24" cy="21" rx="2" ry="3" fill="none" />
        </g>
      ) : kind === "clay" ? (
        <g stroke="#a54e33" strokeWidth="1">
          <path d="m3 19 16-6 10 5-16 7Z" fill="#f3b786" />
          <path d="M3 19v6l10 5v-5Zm10 6 16-7v6l-16 6Z" fill={`url(#${id})`} />
          <path d="m4 9 15-6 10 5-15 7Z" fill="#f3b786" />
          <path d="M4 9v6l10 5v-5Zm10 6 15-7v6l-15 6Z" fill={`url(#${id})`} />
        </g>
      ) : kind === "iron" ? (
        <g stroke="#526775" strokeLinejoin="round">
          <path d="m3 21 5-9 16-5 5 15-16 7Z" fill={`url(#${id})`} />
          <path d="m8 12 16-5-4 10-7 12Z" fill="#a7bcc6" />
          <path d="m8 12 12 5 4-10" fill="#d7e5e7" />
          <path d="m20 17 9 5-16 7Z" fill="#657e8b" />
        </g>
      ) : (
        <g fill={`url(#${id})`} stroke="#a5782a" strokeWidth=".7">
          <path d="m13 29 6-23m1 24L13 9" fill="none" strokeWidth="1.8" />
          <path d="M19 3c-5 3-4 7-1 9 4-2 5-5 1-9ZM16 13c-6-5-9-1-4 5l3 1Zm3 0c6-6 10-2 4 4l-6 3ZM14 21c-6-5-9-2-5 3l4 2Zm3 0c7-6 11-2 5 3l-7 3Z" />
        </g>
      )}
    </svg>
  );
}
